export const getIsFetching = state => state.processCip.isFetching;
export const getErrorMessage = state => state.processCip.errorMessage;
export const getData = state => state.processCip.data;
export const getPaymentType = state => state.processCip.paymentType;
export const getUseridCountry = state => state.user.data.user.service.idCountry;
